export default (hsh, { by }) => {
  return hsh.reduce((newHsh, value) => {
    const key = value[by]
    newHsh[key] ||= []
    newHsh[key].push(value)
    return newHsh
  }, {})
}
